// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArticleSearch":"bbn_a bik_ea bik_sn","ArticleSearch__items":"bbn_b bik_tg","ArticleSearch__item":"bbn_c bik_th"};